"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _MomentTypes = require("customer-data-properties/date/MomentTypes");

var SimpleDate = _interopRequireWildcard(require("UIComponents/core/SimpleDate"));

var _UIDatePicker = _interopRequireDefault(require("UIComponents/input/UIDatePicker"));

var _UIInlineDateInput = _interopRequireDefault(require("UIComponents/input/UIInlineDateInput"));

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

function toTimestamp(momentType, type, simpleDate) {
  if (!simpleDate) {
    return null;
  }

  if (type === 'date') {
    return SimpleDate.toMomentUTC(simpleDate).valueOf();
  } else {
    var result;

    if (momentType === _MomentTypes.MomentTypes.PORTAL) {
      result = SimpleDate.toMomentPortalTz(simpleDate);
    } else {
      result = SimpleDate.toMoment(simpleDate);
    }

    if (type === 'endOfDay') {
      result = result.endOf('day');
    }

    return result.valueOf();
  }
}

var propTypes = {
  momentType: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string,
  style: _react.PropTypes.object,
  onChange: _react.PropTypes.func.isRequired,
  inline: _react.PropTypes.bool,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};
var defaultProps = {
  momentType: _MomentTypes.MomentTypes.USER,
  onChange: _emptyFunction.default
};

var CRMPropertyDateInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CRMPropertyDateInput, _React$Component);

  function CRMPropertyDateInput() {
    var _this;

    (0, _classCallCheck2.default)(this, CRMPropertyDateInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CRMPropertyDateInput).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CRMPropertyDateInput, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      if (this.props.inline) {
        return _UIInlineDateInput.default;
      }

      return _UIDatePicker.default;
    }
  }, {
    key: "getMoment",
    value: function getMoment() {
      var _this$props = this.props,
          momentType = _this$props.momentType,
          type = _this$props.type;
      var valueProp = this.props.value;
      var value = valueProp || valueProp === 0 ? Number(valueProp) : valueProp;

      if (!value && value !== 0) {
        return null;
      }

      if (type === 'date') {
        return _I18n.default.moment.utc(value);
      }

      switch (momentType) {
        case _MomentTypes.MomentTypes.PORTAL:
          return _I18n.default.moment.portalTz(value);

        case _MomentTypes.MomentTypes.USER:
          return _I18n.default.moment.userTz(value);

        case _MomentTypes.MomentTypes.MOMENT:
          return _I18n.default.moment(value);

        default:
          return undefined;
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var moment = this.getMoment();

      if (moment) {
        return SimpleDate.fromMoment(moment);
      }

      return null;
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          momentType = _this$props2.momentType,
          type = _this$props2.type;
      var timestamp = toTimestamp(momentType, type, evt.target.value);

      if (isNaN(timestamp)) {
        return;
      }

      onChange((0, _SyntheticEvent.default)(timestamp));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var DateInput = this.getComponent();
      var transferableProps = (0, _omit.default)(['momentType', 'type', 'isInline', 'showPlaceholder', 'propertyInputComponentConfig', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();
      return _react.default.createElement(DateInput, (0, _extends2.default)({}, transferableProps, {
        onChange: this.handleChange,
        ref: function ref(input) {
          _this2.input = input;
        },
        value: this.getValue()
      }));
    }
  }]);
  return CRMPropertyDateInput;
}(_react.default.Component);

exports.default = CRMPropertyDateInput;
CRMPropertyDateInput.propTypes = propTypes;
CRMPropertyDateInput.defaultProps = defaultProps;
module.exports = exports.default;